const outlinewidth = {
  name: "outline-width",
  path: "/outline-width",
  title: "outline-width",
  description: "Utilities for controlling the width of an element's outline.",
  value: {
    'outline-width': {
      'outline': '1px;',
      'outline-<number>': '<number>px;',
      'outline-[<value>]': '<value>;',
    },
  },
  exampleData: [
    {
      example: {
        code: `<button class="outline outline-offset-2 ...">Button A</button>
<button class="outline-2 outline-offset-2 ...">Button B</button>
<button class="outline-4 outline-offset-2 ...">Button C</button>
<button class="outline-4 outline-offset-[6px] ...">Button d</button>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">outline</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-2</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-4</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-[6px]</code> to set the outline width of an element.
      </p>
      <div class="grid grid-columns-1 gap-4 text-sm text-color-white sm:grid-columns-4">
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">outline</p>
            <button type="button" tabindex="-1" class="outline outline-offset-2 outline-color-purple-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button A</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">outline-2</p>
            <button type="button" tabindex="-1" class="outline-2 outline-offset-2  outline-color-purple-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button B</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">outline-4</p>
            <button type="button" tabindex="-1" class="outline-4 outline-offset-2  outline-color-purple-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button C</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">outline-[6px]</p>
            <button type="button" tabindex="-1" class="outline-[6px] outline-offset-2  outline-color-purple-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button D</button>
        </div>
    </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">focus:*</code>
        Focus the button to see the outline added
      </p>
      <div class="flex text-sm justify-center items-center">
        <div class="flex shrink-0 flex-col items-center">
            <button type="button" class="focus:outline-2 outline-offset-2 outline-color-purple-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button A</button>
        </div>
    </div>
      `
    },
  ]
};

export default outlinewidth;
<div className="outline outline-offset-2 focus:outline-2 outline-2 outline-4 outline-[6px] outline-color-purple-500"></div>